import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false);
  const [loading,  setLoading]  = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed. Check credentials.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', background:'#07070a', overflow:'hidden', position:'relative', fontFamily:"'Inter', system-ui, sans-serif" }}>

      {/* Background layers */}
      <div style={{
        position:'absolute', inset:0,
        background:'radial-gradient(ellipse at 30% 20%, rgba(95,141,255,0.12), transparent 55%), radial-gradient(ellipse at 80% 80%, rgba(201,169,110,0.08), transparent 50%), #07070a',
      }} />
      <div style={{
        position:'absolute', inset:0,
        backgroundImage:`url('https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=2000&q=80')`,
        backgroundSize:'cover', backgroundPosition:'center',
        opacity:0.28, filter:'saturate(1.05) brightness(0.6)',
      }} />
      <div style={{
        position:'absolute', inset:0,
        background:'linear-gradient(105deg, rgba(7,7,10,0.96) 0%, rgba(7,7,10,0.7) 42%, rgba(7,7,10,0.35) 100%)',
      }} />

      {/* Left column — form */}
      <div style={{
        position:'relative', zIndex:10,
        width:480, flexShrink:0,
        padding:'56px 60px',
        display:'flex', flexDirection:'column', justifyContent:'center',
        minHeight:'100vh',
      }}>
        {/* Logo */}
        <div style={{ marginBottom:44 }}>
          <div style={{
            width:52, height:52, borderRadius:12, marginBottom:20,
            display:'flex', alignItems:'center', justifyContent:'center',
            background:'radial-gradient(circle at 30% 30%, #2a3974, #0a1240 70%)',
            border:'1px solid rgba(201,169,110,0.35)',
            boxShadow:'inset 0 0 16px rgba(95,141,255,0.5), 0 4px 20px rgba(95,141,255,0.2)',
          }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 3h12l4 6-10 13L2 9z"/><path d="M11 3 6 9h12L13 3"/><path d="M2 9h20"/>
            </svg>
          </div>
          <p style={{ fontSize:11, letterSpacing:'3px', color:'#c9a96e', textTransform:'uppercase', fontWeight:500, marginBottom:20 }}>
            SUDATH GEMS · EST. 1989
          </p>
          <h1 style={{ fontFamily:"'Fraunces', Georgia, serif", fontWeight:300, fontSize:40, lineHeight:1.15, color:'#f6f1e7', letterSpacing:'-0.5px', margin:0 }}>
            Welcome back to the <em style={{ fontStyle:'italic', color:'#c9a96e' }}>portal.</em>
          </h1>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:18 }}>
            <label style={{ display:'block', fontSize:11, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(255,255,255,0.45)', marginBottom:8, fontWeight:500 }}>
              Email address
            </label>
            <div style={{ position:'relative' }}>
              <div style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'rgba(255,255,255,0.3)' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              </div>
              <input
                type="email" required autoFocus
                value={email} onChange={e => setEmail(e.target.value)}
                placeholder="admin@ceylongems.com"
                style={{
                  width:'100%', padding:'12px 14px 12px 40px',
                  background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)',
                  borderRadius:8, color:'#f6f1e7', fontSize:13.5,
                  fontFamily:'inherit', outline:'none', transition:'all 0.15s',
                }}
                onFocus={e=>{ e.target.style.borderColor='#7a5d2c'; e.target.style.boxShadow='0 0 0 3px rgba(201,169,110,0.15)'; }}
                onBlur={e=>{ e.target.style.borderColor='rgba(255,255,255,0.12)'; e.target.style.boxShadow='none'; }}
              />
            </div>
          </div>

          <div style={{ marginBottom:24 }}>
            <label style={{ display:'block', fontSize:11, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(255,255,255,0.45)', marginBottom:8, fontWeight:500 }}>
              Password
            </label>
            <div style={{ position:'relative' }}>
              <div style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'rgba(255,255,255,0.3)' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              </div>
              <input
                type={showPw ? 'text' : 'password'} required
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width:'100%', padding:'12px 44px 12px 40px',
                  background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)',
                  borderRadius:8, color:'#f6f1e7', fontSize:13.5,
                  fontFamily:'inherit', outline:'none', transition:'all 0.15s',
                }}
                onFocus={e=>{ e.target.style.borderColor='#7a5d2c'; e.target.style.boxShadow='0 0 0 3px rgba(201,169,110,0.15)'; }}
                onBlur={e=>{ e.target.style.borderColor='rgba(255,255,255,0.12)'; e.target.style.boxShadow='none'; }}
              />
              <button type="button" onClick={() => setShowPw(!showPw)} style={{
                position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                color:'rgba(255,255,255,0.35)', padding:4, transition:'color 0.15s',
              }}
              onMouseEnter={e=>e.currentTarget.style.color='rgba(255,255,255,0.7)'}
              onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.35)'}>
                {showPw
                  ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                }
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} style={{
            width:'100%', padding:'14px 24px',
            background:'linear-gradient(135deg, #c9a96e, #7a5d2c)',
            color:'#0c0c10', fontFamily:'inherit', fontWeight:600, fontSize:13,
            borderRadius:8, cursor:loading?'not-allowed':'pointer',
            display:'flex', alignItems:'center', justifyContent:'center', gap:10,
            border:'none', transition:'all 0.15s', opacity:loading?0.7:1,
            boxShadow:'0 8px 24px rgba(201,169,110,0.25), inset 0 1px 0 rgba(255,255,255,0.4)',
          }}
          onMouseEnter={e=>{ if(!loading){ e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(201,169,110,0.35), inset 0 1px 0 rgba(255,255,255,0.4)'; }}}
          onMouseLeave={e=>{ e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='0 8px 24px rgba(201,169,110,0.25), inset 0 1px 0 rgba(255,255,255,0.4)'; }}>
            {loading ? 'Signing in…' : 'Sign in to portal'}
            {!loading && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            )}
          </button>
        </form>

        {/* Footer */}
        <div style={{ marginTop:32, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <a href="/" style={{ fontSize:12, color:'rgba(255,255,255,0.3)', display:'flex', alignItems:'center', gap:6, transition:'color 0.15s' }}
            onMouseEnter={e=>e.currentTarget.style.color='rgba(255,255,255,0.6)'}
            onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.3)'}>
            ← Back to site
          </a>
          <span style={{ fontSize:11, color:'rgba(255,255,255,0.2)' }}>v1.0.0</span>
        </div>
      </div>

      {/* Right column — spinning gem */}
      <div style={{ flex:1, position:'relative', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ position:'relative', width:340, height:340 }}>
          {/* Glow */}
          <div style={{
            position:'absolute', inset:'-30%',
            background:'radial-gradient(closest-side, rgba(95,141,255,0.45), transparent 70%)',
            filter:'blur(20px)', animation:'gemPulse 3.4s ease-in-out infinite',
          }} />
          {/* Spinning gem placeholder (SVG) */}
          <div style={{
            width:'100%', height:'100%',
            display:'flex', alignItems:'center', justifyContent:'center',
            animation:'gemSpin 30s linear infinite',
            filter:'drop-shadow(0 30px 60px rgba(0,0,0,0.6)) drop-shadow(0 0 50px rgba(95,141,255,0.35))',
          }}>
            <svg viewBox="0 0 200 200" width="300" height="300" fill="none">
              <defs>
                <linearGradient id="gf1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#a8c8ff"/><stop offset="100%" stopColor="#1a4a9c"/></linearGradient>
                <linearGradient id="gf2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#c9dfff"/><stop offset="100%" stopColor="#3a6bbf"/></linearGradient>
                <linearGradient id="gf3" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#ddeeff"/><stop offset="100%" stopColor="#0a2060"/></linearGradient>
              </defs>
              <polygon points="100,20 160,75 100,180 40,75" fill="url(#gf1)" stroke="rgba(201,169,110,0.6)" strokeWidth="0.8"/>
              <polygon points="100,20 160,75 100,70" fill="url(#gf2)" opacity="0.9"/>
              <polygon points="100,20 40,75 100,70" fill="url(#gf3)" opacity="0.75"/>
              <polygon points="40,75 100,70 100,180" fill="#0a1a50" opacity="0.8"/>
              <polygon points="160,75 100,70 100,180" fill="#1a3a8a" opacity="0.7"/>
              <line x1="100" y1="20" x2="100" y2="70" stroke="rgba(255,255,255,0.5)" strokeWidth="0.6"/>
              <line x1="40" y1="75" x2="160" y2="75" stroke="rgba(255,255,255,0.3)" strokeWidth="0.5"/>
            </svg>
          </div>
          {/* Sparkles */}
          {[
            { top:'10%', left:'15%', delay:'0s' },
            { top:'20%', right:'10%', delay:'1.2s' },
            { bottom:'25%', left:'8%', delay:'2.1s' },
            { bottom:'15%', right:'18%', delay:'0.7s' },
            { top:'50%', right:'5%', delay:'1.8s' },
          ].map((s, i) => (
            <div key={i} style={{
              position:'absolute', width:4, height:4, borderRadius:'50%',
              background:'#fff', boxShadow:'0 0 8px #fff, 0 0 16px #c9a96e',
              animation:`sparkle 3.5s ease-in-out infinite`,
              animationDelay: s.delay, ...s,
            }} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes gemSpin { from{ transform:rotate(0deg); } to{ transform:rotate(360deg); } }
        @keyframes gemPulse { 0%,100%{ opacity:0.5; transform:scale(1); } 50%{ opacity:0.85; transform:scale(1.08); } }
        @keyframes sparkle  { 0%,100%{ opacity:0; transform:scale(0.4); } 50%{ opacity:1; transform:scale(1); } }
      `}</style>
    </div>
  );
}
